import React from 'react';
import Slider from "react-slick";
import movie from '../../assets/movie.webp';


function Shops() {

  

  const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
    slidesToScroll: 3,
     
    };
  return (
    <div >
          <Slider {...settings}>
        <div className='grid grid-cols-3'>
          
        <div >
        <img src={movie} alt="" />
        <h1>heloooo</h1>
          </div>
          
                  <div >
        <img src={movie} alt="" />
        <h1>heloooo</h1>
          </div>
          
                  <div >
        <img src={movie} alt="" />
        <h1>heloooo</h1>
          </div>
          
                  <div >
        <img src={movie} alt="" />
        <h1>heloooo</h1>
          </div>
                  <div >
        <img src={movie} alt="" />
        <h1>heloooo</h1>
          </div>
                  <div >
        <img src={movie} alt="" />
        <h1>heloooo</h1>
          </div>
                  <div >
        <img src={movie} alt="" />
        <h1>heloooo</h1>
        </div>
          </div>
          
        </Slider>
    </div>
  )
}

export default Shops